var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"modal-header"},[(_vm.showBackCaret && !_vm.removeBackCaret)?_c('font-awesome-icon',{staticClass:"back",attrs:{"role":"button","icon":['far', 'chevron-left'],"aria-label":"back"},on:{"click":function($event){return _vm.$emit('back')}}}):_c('span'),_c('span',{staticClass:"modal-title b360-handle-overflow",attrs:{"role":"heading","data-test":"modal-title","title":_vm.truncateModalFields({
				fieldName: _vm.getHeading,
				fieldLength: 36,
				attributeName: 'title',
			})}},[_vm._v("\n\t\t"+_vm._s(_vm.truncateModalFields({
				fieldName: _vm.getHeading,
				fieldLength: 36,
			}))+"\n\t")]),_c('font-awesome-icon',{staticClass:"close",attrs:{"icon":['fal', 'times'],"role":"button","aria-label":"close"},on:{"click":function($event){return _vm.$emit('close')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }